import { Center, Image, Stack, Table, Text } from '@mantine/core';
import React from 'react';
import { DataTableBodyProps } from '.';
import TableActionMenu from './TableActionMenu';
import Dates from 'components/Dates';

const TBody: React.FC<DataTableBodyProps> = ({
  columns,
  data,
  isNumbering,
  emptyMessage,
  emptyMessageTitle = 'No data available.',
  emptyMessageDescription = 'Click create button to add data here.',
  viewText = 'View Detail',
  deleteText = 'Delete',
  editText = 'Edit',
  copyText = 'Copy',
  activePage,
  activePageSize,
  urlEmptyImage = '/images/illustration-not-found.svg',
  handleDelete,
  handleEdit,
  handleView,
  handleCopy,
  handleApproved: _handleApproved,
  handleRejected: _handleRejected,
  canView,
  canEdit,
  canDelete,
  canApproved: _canApproved,
  canRejected: _canRejected
}) => {
  const activeColumn = columns.filter((column) => column.active === true);
  if (data.length === 0) {
    return (
      <Table.Tbody>
        <Table.Tr>
          <Table.Td
            colSpan={isNumbering ? activeColumn.length + 1 : activeColumn.length}
            style={{ textAlign: 'center' }}
          >
            {emptyMessage || (
              <Center py={40}>
                <Stack gap={'md'}>
                  <Image src={urlEmptyImage} alt='Empty Illustration' />
                  <Stack gap={0} justify='center'>
                    <Text fw={700}>{emptyMessageTitle}</Text>
                    <Text fz={14} fw={500}>
                      {emptyMessageDescription}
                    </Text>
                  </Stack>
                </Stack>
              </Center>
            )}
          </Table.Td>
        </Table.Tr>
      </Table.Tbody>
    );
  }

  return (
    <Table.Tbody>
      {data.map((cell, index) => {
        const itemNumber =
          activePage !== 1
            ? (Number(activePage) - 1) * Number(activePageSize) + index + 1
            : index + 1;
        const viewHandler =
          handleView && (canView ? (canView(cell) ? handleView : undefined) : handleView);
        const editHandler =
          handleEdit && (canEdit ? (canEdit(cell) ? handleEdit : undefined) : handleEdit);
        const deleteHandler =
          handleDelete && (canDelete ? (canDelete(cell) ? handleDelete : undefined) : handleDelete);
        return (
          <Table.Tr key={index}>
            {isNumbering && (
              <Table.Td>
                <Text fz={14} fw={500}>
                  {itemNumber}.
                </Text>
              </Table.Td>
            )}

            {columns.map((column, i) => {
              if (!column.active) return null;

              if (column.props === 'startDate' || column.props === 'endDate') {
                return (
                  <Table.Td key={i}>
                    <Dates fz={14} fw={500} date={cell[column.props]} />
                  </Table.Td>
                );
              }

              if (typeof column.props === 'function') {
                return <Table.Td key={i}>{column.props(cell, index)}</Table.Td>;
              }

              if (column.props === 'action') {
                return (
                  <Table.Td key={i}>
                    <TableActionMenu
                      data={cell}
                      viewText={viewText}
                      editText={editText}
                      deleteText={deleteText}
                      copyText={copyText}
                      handleDelete={deleteHandler}
                      handleEdit={editHandler}
                      handleView={viewHandler}
                      handleCopy={handleCopy}
                    />
                  </Table.Td>
                );
              }

              if (!cell[column.props]) {
                return (
                  <Table.Td key={i}>
                    <Text fz={14} fw={500}>
                      -
                    </Text>
                  </Table.Td>
                );
              }

              return (
                <Table.Td key={i}>
                  <Text fz={14} fw={500}>
                    {cell[column.props]}
                  </Text>
                </Table.Td>
              );
            })}
          </Table.Tr>
        );
      })}
    </Table.Tbody>
  );
};

export default TBody;
